import React from "react";
import { ThemeColors } from "../../../colors";
import styles from "./expert-marquee.module.css";

// Placeholder data generator
const EXPERTS_ROW_1 = Array(10).fill(null).map((_, i) => ({
  id: `r1-${i}`,
  name: `Dr. Jane Doe ${i + 1}`,
  institution: "Harvard Medical School",
  specialty: "Cardiology"
}));

const EXPERTS_ROW_2 = Array(10).fill(null).map((_, i) => ({
  id: `r2-${i}`,
  name: `Dr. Sarah Smith ${i + 1}`,
  institution: "Mayo Clinic",
  specialty: "Neurology"
}));

export default function ExpertMarquee() {
  return (
    <section className={styles.section}>
      <div className={styles.headerContainer}>
        <h2 className={styles.title}>Explore the Experts</h2>
        <p className={styles.subhead}>
          132 Hand-Selected and Vetted Experts. All Female.
        </p>
      </div>

      <div className={styles.marqueeContainer}>
        {/* Row 1: Left Scroll */}
        <div className={`${styles.marqueeRow} ${styles.scrollLeft}`}>
          {/* Duplicate for seamless loop */}
          {[...EXPERTS_ROW_1, ...EXPERTS_ROW_1].map((expert, idx) => (
            <div key={`${expert.id}-${idx}`} className={styles.expertCard}>
              <div className={styles.headshot} /> {/* Placeholder Image */}
              <div className={styles.info}>
                <span className={styles.name}>{expert.name}</span>
                <span className={styles.specialty}>{expert.specialty}</span>
                <span className={styles.institution}>{expert.institution}</span>
              </div>
            </div>
          ))}
        </div>

        {/* Row 2: Right Scroll */}
        <div className={`${styles.marqueeRow} ${styles.scrollRight}`}>
          {/* Duplicate for seamless loop */}
          {[...EXPERTS_ROW_2, ...EXPERTS_ROW_2].map((expert, idx) => (
            <div key={`${expert.id}-${idx}`} className={styles.expertCard}>
              <div className={styles.headshot} /> {/* Placeholder Image */}
              <div className={styles.info}>
                <span className={styles.name}>{expert.name}</span>
                <span className={styles.specialty}>{expert.specialty}</span>
                <span className={styles.institution}>{expert.institution}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className={styles.diligenceContainer}>
        <h3 className={styles.diligenceTitle}>A New Level of Diligence</h3>
        <p className={styles.diligenceText}>
          Every expert featured in this book didn't just provide a quote—they <strong>reviewed and approved</strong> the medical findings associated with their expertise. Combined with three years of deep-dive reporting into the <strong>latest peer-reviewed studies</strong>, followed by <strong>independent fact-checking</strong>, this is the most verified resource in women's health today.
        </p>
      </div>

    </section>
  );
}
